import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { userHistoryOptionsSchema } from '../../../../../shared/source/data-contract/user-history';

import type { UserHistoryOptions } from '../../../../../shared/source/data-contract/user-history';
import type { UseQueryResult } from '@tanstack/react-query';

export const useUserHistoryOptionsQuery = (userId: string): UseQueryResult<UserHistoryOptions> => {
    const userHistoryOptionsUrl = `/users/${userId}/history/options` as const;
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(userHistoryOptionsSchema, {
                pathname: userHistoryOptionsUrl,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: [userHistoryOptionsUrl, 'GET'],
    });
};
